import { CommunityPostSettings } from '@amityco/js-sdk';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { toHumanString } from '../../../helpers/toHumanString';
import customizableComponent from '../../../core/hocs/customization';
import Button from '../../../core/components/Button';
import { PendingPostsBanner } from '../../../social/components/CommunityInfo/PendingPostsBanner';
import { backgroundImage as communityCoverPlaceholder } from '../../../icons/CommunityCoverPicture';
import { Count, Container, Header, OptionMenu, CategoriesList, Description, JoinButton, PlusIcon, PencilIcon, CountsContainer, Cover, CoverContent, Divider, Content, CommunityName, } from './styles';
const UICommunityInfo = ({ communityId, communityCategories, pendingPostsCount, postsCount, membersCount, description, isJoined, isOfficial, isPublic, avatarFileUrl, canEditCommunity, onEditCommunity, joinCommunity, onClickLeaveCommunity, canLeaveCommunity, canReviewPosts, isAnonymous, name, postSetting, }) => {
    const { formatMessage } = useIntl();
    return (React.createElement(Container, { "data-qa-anchor": "community-info" },
        React.createElement(Cover, { backgroundImage: avatarFileUrl !== null && avatarFileUrl !== void 0 ? avatarFileUrl : communityCoverPlaceholder },
            React.createElement(CoverContent, null,
                React.createElement(CommunityName, { "data-qa-anchor": "community-info", isOfficial: isOfficial, isPublic: isPublic, isTitle: true, name: name, truncate: 2 }),
                React.createElement(CategoriesList, null, (communityCategories || []).join(', ')))),
        React.createElement(Content, null,
            React.createElement(Header, null,
                React.createElement(CountsContainer, null,
                    React.createElement(Count, null,
                        React.createElement("div", { className: "countNumber" }, toHumanString(postsCount || 0)),
                        React.createElement("div", { className: "countType" },
                            React.createElement(FormattedMessage, { id: "community.posts" }))),
                    !isAnonymous && (React.createElement(React.Fragment, null,
                        React.createElement(Divider, null),
                        React.createElement(Count, null,
                            React.createElement("div", { className: "countNumber" }, toHumanString(membersCount || 0)),
                            React.createElement("div", { className: "countType" },
                                React.createElement(FormattedMessage, { id: "community.members" })))))),
                isJoined && (React.createElement(OptionMenu, { "data-qa-anchor": "community-info-options-button", options: [
                        canEditCommunity && {
                            name: formatMessage({ id: 'community.settings' }),
                            action: () => onEditCommunity(communityId),
                            dataQaAnchorMenuItem: 'settings',
                        },
                        canLeaveCommunity && {
                            name: formatMessage({ id: 'community.leaveCommunity' }),
                            action: () => onClickLeaveCommunity(communityId),
                            dataQaAnchorMenuItem: 'leave-community',
                        },
                    ].filter(Boolean) }))),
            description && (React.createElement(Description, { "data-qa-anchor": "community-info-description" }, description)),
            !isJoined && (React.createElement(JoinButton, { "data-qa-anchor": "community-info-join-button", onClick: () => joinCommunity(communityId) },
                React.createElement(PlusIcon, null),
                " ",
                React.createElement(FormattedMessage, { id: "community.join" }))),
            isJoined && canEditCommunity && (React.createElement(Button, { isFullWidth: true, "data-qa-anchor": "community-info-edit-button", onClick: () => onEditCommunity(communityId) },
                React.createElement(PencilIcon, null),
                " ",
                React.createElement(FormattedMessage, { id: "community.editProfile" }))),
            postSetting === CommunityPostSettings.ADMIN_REVIEW_POST_REQUIRED &&
                isJoined &&
                pendingPostsCount > 0 && (React.createElement(PendingPostsBanner, { canReviewPosts: canReviewPosts, postsCount: pendingPostsCount })))));
};
UICommunityInfo.propTypes = {
    communityId: PropTypes.string.isRequired,
    communityCategories: PropTypes.arrayOf(PropTypes.string),
    pendingPostsCount: PropTypes.number,
    postsCount: PropTypes.number,
    membersCount: PropTypes.number,
    description: PropTypes.string,
    isJoined: PropTypes.bool,
    isOfficial: PropTypes.bool,
    isPublic: PropTypes.bool,
    avatarFileUrl: PropTypes.string,
    canEditCommunity: PropTypes.bool,
    joinCommunity: PropTypes.func,
    canLeaveCommunity: PropTypes.bool,
    canReviewPosts: PropTypes.bool,
    isAnonymous: PropTypes.bool,
    name: PropTypes.string,
    postSetting: PropTypes.string,
    onClickLeaveCommunity: PropTypes.func,
    onEditCommunity: PropTypes.func,
};
export default customizableComponent('UICommunityInfo', UICommunityInfo);
//# sourceMappingURL=UICommunityInfo.js.map